/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Icon } from "@resource/atlas";
import { atlasChevronRight, atlasPlay } from "@resource/atlas/icons";
import defaultAvatarImage from "icons/legacy/default-avatar.svg";
import { useState } from "react";

const useStyles = makeStyles(() => ({
  imgContainer: {
    aspectRatio: "1",
    display: "flex",
  },
  img: {
    height: "100%",
    width: "100%",
    display: "block",
    overflow: "hidden",
    margin: "auto",
    cursor: "pointer",
    borderRadius: "4px",
    objectFit: "cover",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
    cursor: "pointer",
    "& p": {
      marginRight: "0px",
      transition: "100ms ease margin",
    },
    "&:hover": {
      "& p": {
        marginLeft: "4px",
        marginRight: "4px",
        transition: "100ms ease margin",
      },
    },
  },
  text: {
    fontWeight: "bold",
  },
}));

type InterviewerProps = {
  id: string;
  firstName: string;
  imageUrl: string;
  videoIntroductionUrl?: string | null;
  onClick: () => void;
};

function Interviewer({
  id,
  firstName,
  imageUrl,
  videoIntroductionUrl,
  onClick,
}: InterviewerProps) {
  const [imageErrored, setImageErrored] = useState(false);

  const classes = useStyles();
  return (
    <div key={id}>
      <div
        className="cursor-pointer relative"
        style={{
          aspectRatio: "1/1",
        }}
        onClick={onClick}
        role="button"
        tabIndex={-1}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className={classes.img}
          src={imageUrl && !imageErrored ? imageUrl : defaultAvatarImage.src}
          alt={firstName}
          width="100%"
          height="100%"
          onError={() => setImageErrored(true)}
        />
        {videoIntroductionUrl && (
          <div className="absolute bottom-2 right-2 rounded-full bg-red-500 flex items-center justify-center w-10 h-10 text-white">
            <Icon content={atlasPlay} size="medium" />
          </div>
        )}
      </div>
      <div className={classes.title}>
        <Typography className={classes.text} onClick={onClick}>
          {firstName}
        </Typography>
        <Icon size="medium" content={atlasChevronRight} />
      </div>
    </div>
  );
}

export default Interviewer;
